module.exports = __webpack_public_path__ + "static/media/send-letter-info-img4.a9c17c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/send-letter-info-img4.png
// module id = 1317
// module chunks = 1